import { SmallIcon } from "Components/SmallIcon";
import React from "react";
import { HomepageLink } from "Views/Shared/HomepageLink";
import { Heading } from "../../Components/Heading";
import { useDocumentTitle } from "Components/Hooks";
import { AdditionalUnderwritingRequiredProps } from "SharedConstants/Schema";

export function AdditionalUnderwritingRequired(
  props: AdditionalUnderwritingRequiredProps,
) {
  const title = "Additional Underwriting Required";
  useDocumentTitle(`${title} - ${props.TitleProps.PageTitleSuffix}`);
  return (
    <>
      <Heading {...props} title={title} />
      <div>Thank you for your application!</div>
      <div style={{ marginTop: "0.5em" }}>
        Based on the answers provided, your submission requires a custom quote.
        An underwriter will contact you shortly.
      </div>
      <HomepageLink {...props.HomepageLinkProps} />
      <div className="has-text-centered">
        <a href={props.BackUrl} className="button" style={{ marginTop: "1em" }}>
          <SmallIcon name="fa-arrow-left" />
          <span>Back (Make Edits)</span>
        </a>
      </div>
    </>
  );
}
